import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IAddDependentItemEvent } from '../models/iadd-dependent-items-event';
import { IDeleteDependentItemEvent } from '../models/idelete-dependent-item-event';
import { IItemRecordChangedEvent } from '../models/iitem-record-changed-event';
import { IItemResetEvent } from '../models/iitem-reset-event';
import { IItemScratchPadChangeEvent } from '../models/iitem-scratch-pad-change-event';
import { IScopingItemGroupMapping } from '../models/iscoping-item-group-mapping';
import { IUpdateDependentItemEvent } from '../models/iupdate-dependent-item-event';
import { ScopingItemGroupMapping } from '../models/scoping-item-group-mapping';

@Injectable()
export class ItemManagementBrokerService {

  private ChangedItemGroupMappings: ScopingItemGroupMapping[] = [];

  public latestScopingItemGroupMapping: BehaviorSubject<IScopingItemGroupMapping[]>;
  public ScratchPadChangeEvent: BehaviorSubject<IItemScratchPadChangeEvent>;
  public AddDependentItemEvent: BehaviorSubject<IAddDependentItemEvent>;
  public UpdateDependentItemEvent: BehaviorSubject<IUpdateDependentItemEvent>;
  public DeleteDependentItemEvent: BehaviorSubject<IDeleteDependentItemEvent>;
  public RecordChangedEvent: BehaviorSubject<IItemRecordChangedEvent>;
  public ResetEvent: BehaviorSubject<IItemResetEvent>;

  public DragDropEvent: BehaviorSubject<any>;

  constructor() {

    this.latestScopingItemGroupMapping = new BehaviorSubject(null);
    this.ScratchPadChangeEvent = new BehaviorSubject(null);
    this.AddDependentItemEvent = new BehaviorSubject(null);
    this.UpdateDependentItemEvent = new BehaviorSubject(null);
    this.DeleteDependentItemEvent = new BehaviorSubject(null);
    this.RecordChangedEvent = new BehaviorSubject(null);
    this.ResetEvent = new BehaviorSubject(null);

    this.DragDropEvent = new BehaviorSubject(null);
  }

  public get anyChanges(): boolean {
    return this.ChangedItemGroupMappings.length > 0;
  }

  public updateGroup(group: IScopingItemGroupMapping) {
    let existingIndex = this.ChangedItemGroupMappings.findIndex(f => f.ScopingItemId === group.ScopingItemId);

    if (existingIndex !== -1) {
      this.ChangedItemGroupMappings.splice(existingIndex, 1, group);
    } else {
      this.ChangedItemGroupMappings = [...this.ChangedItemGroupMappings, group];
    }

    this.broadcastChanges();
  }

  public clearChanges() {
    this.ChangedItemGroupMappings = [];
    this.broadcastChanges();
  }

  private broadcastChanges() {
    this.RecordChangedEvent.next({
      ItemGroupMappings: this.ChangedItemGroupMappings,
    });
  }
}